import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faMinus } from '@fortawesome/pro-regular-svg-icons'
import i18n from 'Lib/i18n'
import { isMobile } from 'react-device-detect'
import { MobileTextCss } from 'Features/pricing/tabs/PaidMarketing/PaidMarketing.styled'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

const faCheckIcon = (
  <FontAwesomeIcon icon={faCheck as IconProp} color={'var(--colors-primaryColor)'} width={'16px'} />
)
const faMinusIcon = <FontAwesomeIcon icon={faMinus as IconProp} width={'16px'} />

export const PaidMarketingTableData = {
  account: [
    {
      title: i18n.t('paid_marketing.features.domains_protected', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.domains_protected', { ns: 'pricing' }),
      cells: [
        i18n.t('paid_marketing.features.up_to_number', { ns: 'pricing', number: 5 }),
        i18n.t('paid_marketing.features.up_to_number', { ns: 'pricing', number: 30 }),
        i18n.t('paid_marketing.features.unlimited', { ns: 'pricing' }),
      ],
    },
    {
      title: i18n.t('paid_marketing.features.yearly_paid_visits', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.yearly_visits', { ns: 'pricing' }),
      cells: [
        i18n.t('paid_marketing.features.up_to_number', { ns: 'pricing', number: '1M' }),
        i18n.t('paid_marketing.features.up_to_number', { ns: 'pricing', number: '1M' }),
        i18n.t('paid_marketing.features.unlimited', { ns: 'pricing' }),
      ],
    },
    {
      title: i18n.t('paid_marketing.features.marketing_platforms_protected', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.marketing_platforms_protected', { ns: 'pricing' }),
      featureNameCss: isMobile ? MobileTextCss : {},
      cellCss: isMobile ? MobileTextCss : {},
      cells: [
        i18n.t('paid_marketing.features.google_meta_microsoft', { ns: 'pricing' }),
        i18n.t('paid_marketing.features.google_meta_microsoft', { ns: 'pricing' }),
        i18n.t('paid_marketing.features.thirteen_marketing_platforms', { ns: 'pricing' }),
      ],
    },
  ],
  protection: [
    {
      title: i18n.t('paid_marketing.features.ip_blocking', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.ip_blocking', { ns: 'pricing' }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('paid_marketing.features.ai_bot_detection', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.ai_bot_detection', { ns: 'pricing' }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('paid_marketing.features.audience_exclusion', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.audience_exclusion', { ns: 'pricing' }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('paid_marketing.features.pixel_guard', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.pixel_guard', { ns: 'pricing' }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('paid_marketing.features.affiliate_fraud', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.affiliate_fraud', { ns: 'pricing' }),
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
    {
      title: i18n.t('paid_marketing.features.policy_management', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.policy_management', { ns: 'pricing' }),
      cells: [faCheckIcon, faCheckIcon, i18n.t('paid_marketing.customized', { ns: 'pricing' })],
    },
  ],
  reporting: [
    {
      title: i18n.t('paid_marketing.features.customized_reporting', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.customized_reporting', { ns: 'pricing' }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('paid_marketing.features.session_recording', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.session_recording', { ns: 'pricing' }),
      cells: [faCheckIcon, faMinusIcon, faMinusIcon],
    },
    {
      title: i18n.t('paid_marketing.features.advanced_reporting', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.advanced_reporting', { ns: 'pricing' }),
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
    {
      title: i18n.t('paid_marketing.features.data_retention', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.data_retention', { ns: 'pricing' }),
      cells: ['90', '90', '180'],
    },
  ],
  service: [
    {
      title: i18n.t('paid_marketing.features.support', { ns: 'pricing' }),
      tooltip: i18n.t('paid_marketing.tooltips.support', { ns: 'pricing' }),
      cells: ['24/7', '24/7', '24/7'],
    },
    {
      title: i18n.t('paid_marketing.features.technical_implementation_manager', {
        ns: 'pricing',
      }),
      tooltip: i18n.t('paid_marketing.tooltips.technical_onboarding_manager', { ns: 'pricing' }),
      featureNameCss: isMobile ? MobileTextCss : {},
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
  ],
}
